import { SimpleFlowDirectiveType } from 'logic/directive/types'
import { toLowerCase } from 'utils/general'

export function getDirectiveSimpleFlowSignupUrl(directiveType: SimpleFlowDirectiveType) {
  return `/${toLowerCase(directiveType)}/signup`
}
